// extracted by mini-css-extract-plugin
export default {"V2BarChartWrap":"V2BarChartWrap--wIByg","V2BarChart":"V2BarChart--Or9Lo","V2BarChartBorder":"V2BarChartBorder--nUJG6","markerAnimationScale":"markerAnimationScale--v9QIR"};